module.exports = __webpack_public_path__ + "img/ABISL.e2c0df51.jpg";